import {type AuthUser} from '@/matic/types/auth';

export function canCreateLattice(user: AuthUser): boolean {
  return user.role !== 'basic';
}

export function canModifyLattice(user: AuthUser): boolean {
  return user.role !== 'basic';
}

export function canDeleteLattice(user: AuthUser): boolean {
  return user.role === 'admin' || user.role === 'quality';
}

export function canRunExtraction(user: AuthUser): boolean {
  return user.role !== 'basic';
}
